// Client-side listing content formatter (mirrors backend generator).

export function buildFullAddress(b) {
  const cityState = [b.city, b.state].filter(Boolean).join(", ");
  return [b.address, cityState, b.zip].filter(Boolean).join(", ");
}

export function trimDescription(desc, limit) {
  const d = (desc || "").trim();
  if (!limit || d.length <= limit) return d;
  return d.slice(0, limit - 1).trimEnd() + "\u2026";
}

export function buildNapBlock(b) {
  const lines = [
    `Business Name: ${b.name || ""}`,
    b.category ? `Category: ${b.category}` : null,
    `Address: ${buildFullAddress(b)}`,
    b.phone ? `Phone: ${b.phone}` : null,
    b.website ? `Website: ${b.website}` : null,
    b.email ? `Email: ${b.email}` : null,
    b.hours ? `Hours: ${b.hours}` : null,
  ].filter(Boolean);
  return lines.join("\n");
}

export function buildDirectoryContent(b, directory) {
  const desc = trimDescription(b.description, directory?.desc_limit);
  return `${buildNapBlock(b)}\n\nDescription:\n${desc}`;
}
